// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoSection_video__iLbll","fullWidth":"VideoSection_fullWidth__bhmxV"};